import { AxiosError } from 'axios';
import ExploreArea from '../../domain/entities/ExploreArea';
import { ExploreAreasApi, newExploreAreasApi } from '../api/backend/api';

interface SearchQuery {
  merchantCategoryId: number;
  areaIds?: number[];
  isParent?: boolean;
  limit?: number;
  parentAreaId?: number;
  query?: string;
}

export class ExploreAreaRepository {
  private api: ExploreAreasApi;

  constructor(api: ExploreAreasApi) {
    this.api = api;
  }

  public async Search(query: SearchQuery): Promise<ExploreArea[]> {
    return this.api
      .exploreAreasList(
        query.merchantCategoryId,
        query.limit,
        query.query,
        query.areaIds,
        query.parentAreaId,
        query.isParent,
      )
      .then(res => {
        if (!res.data.exploreAreas) {
          throw Error('Response Structure is invalid');
        }
        return res.data.exploreAreas.map(init => new ExploreArea(init));
      })
      .catch((err: AxiosError) => {
        // TODO handle error by status
        return Promise.reject(err);
      })
      .catch((err: Error) => {
        return Promise.reject(err);
      });
  }
}

export default new ExploreAreaRepository(newExploreAreasApi());
